<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'conferenceBase',
  mounted () {
    this.$store.commit('user/SET_CONFERENCEID', this.$route.params.conferenceId)
    this.$store.commit('user/SET_TYPE', this.$route.params.type)
  }
}
</script>
